(function(baseUtil) {
  jQuery.extend({

    TitleLocale: {
      '/getpwd': {
        'en': 'Recover Password',
        'zh': '找回密码'
      },
      '/register': {
        'en': 'Register',
        'zh': '注册'
      },
      '/usermgmt': {
        'en': 'User Center',
        'zh': '用户中心'
      }
      // '/mbasic': {
      //   'en': 'Basic Info',
      //   'zh': '基本信息'
      // },
      // '/mchangepw': {
      //   'en': 'Change Password',
      //   'zh': '修改密码'
      // },
      // '/mbindmobile1': {
      //   'en': 'Bind Mobile - Security',
      //   'zh': '绑定手机-安全验证'
      // },
      // '/mbindmobile2': {
      //   'en': 'Bind Mobile',
      //   'zh': '绑定手机'
      // },
      // '/memailcheck': {
      //   'en': 'Email Check',
      //   'zh': '邮箱验证'
      // },
      // '/mchangename': {
      //   'en': 'Edit Nickname',
      //   'zh': '修改昵称'
      // }
    },

    changeTitleByPath(curpath) {
      var locale = baseUtil.getLocale();
      var pathname = window.location.pathname;
      if(pathname.indexOf('usercenter') !== -1){
        if( (locale == 'zh_CN') || (locale == 'zh')){
          window.document.title = '友户通';
        }else if(  (locale == 'zh_HK') ||  (locale == 'zh_TW')){
          window.document.title = '友戶通';
        }else{
          window.document.title = 'YHT';
        }
      }else if(pathname.indexOf('getpwd') !== -1){
        if( (locale == 'zh_CN') || (locale == 'zh')){
          window.document.title = '找回密码';
        }else if(  (locale == 'zh_HK') ||  (locale == 'zh_TW')){
          window.document.title = '找回密碼';
        }else{
          window.document.title = 'Find Password';
        }
      }else if(pathname.indexOf('register') !== -1){
        if( (locale == 'zh_CN') || (locale == 'zh')){
          window.document.title = '注册';
        }else if(  (locale == 'zh_HK') ||  (locale == 'zh_TW')){
          window.document.title = '注册';
        }else{
          window.document.title = 'Register';
        }
      }
    }


  })
})($);
module.exports = $;